export enum TransferType {
   IFSCCode = "IFSCCODE",
   SWIFTCode = "SWIFTCODE"
}

export enum TransferTypeSriLanka {
   SWIFTCode = "SWIFTCODE"
}

export enum AccountType {
   Savings = "SAVING",
   Current = "CURRENT"
}

export const TransferTypeMapping = {
   [TransferType.IFSCCode]: "ifsc",
   [TransferType.SWIFTCode]: "swift"
}

export const TransferTypeSriLankaMapping = {
   [TransferTypeSriLanka.SWIFTCode]: "swift"
}
